module.exports = __webpack_public_path__ + "34804e7fc6696616d32245eb3c735ff5.woff";